import { Component, OnInit, Input, Output, EventEmitter, ElementRef,OnChanges,SimpleChanges } from '@angular/core';
import {CommonService} from '../../app/common.service';
import {ActivatedRoute} from '@angular/router';
@Component({
	selector: 'component-approach',
	templateUrl: './component.approach.html',
	styleUrls: ['./component.approach.css']
})
export class ComponentApproach implements OnInit {

  @Input() theme: any;
  @Input() isFirst: boolean;
  @Output() onGoCourse = new EventEmitter<any>()

  label: any;
  assetsRoute: string = "../../assets";
  buttonTheme: any = {
    'position':'inherit',
    'fontSize': 'fontSize15',
    'buttonElem':[
      {
        'color': 'blue',
        'text': '',
        'className': 'inlineBlockRadiusBtn width-100 margin-auto'
      }
    ]
  }; //按钮主题
  type : string;//是否为pc横版
  isShowBtn : boolean = false;//是否隐藏按钮
	constructor(
	  private el: ElementRef,
    private commonService:CommonService,
    private route: ActivatedRoute,
  ) {}

	ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.label = this.theme.label
    this.buttonTheme.buttonElem[0].text = this.theme.btnTxt;
    this.route.queryParams.subscribe(queryParams=>{
      this.type = queryParams['type'];
    })
    if(this.type){
      this.theme.desc = '请点击左侧边栏中能力考核进行学习 ~';
    }
    this.isShowBtn = localStorage.getItem("source_env") == "LMS_SCORM" && localStorage.getItem("moduleId") && Number(localStorage.getItem("moduleId")) == 4? true: false;
	}


	ngAfterViewInit() {
    if(this.isShowBtn){//隐藏按钮 调整样式
      document.getElementById("approachModule").removeAttribute("style");
      document.getElementById("approachModuleWrap").style.height = "auto";
    }
	}



}



// WEBPACK FOOTER //
// ./src/component-ui/approach/component.approach.ts